import Vuex from "vuex";
import Vue from "vue";
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

Vue.use(Vuex);

const state = {
    modList: [],
    
};

export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations
});
